/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
import RahmaUnifiedChat from "./RahmaUnifiedChat";

export default function FloatingWidgets(props) {
  const {
    onToggleRahmaChat = () => {},
    onOpenZakatPopup = () => {},
  } = props || {};

  return (
    <>
      <div className="p-float-icons donat-i">
        <a href="/quick-donation" className="float-btn donate">
          <i className="fas fa-hands-holding-circle"></i>
          <span>
            {"Donate"}
          </span>
        </a>
      </div>
      <div className="p-float-icons zakat-i">
        <a
          id="openZakatPopup"
          className="float-btn zakat"
          onClick={(event) => {
            event.preventDefault();
            onOpenZakatPopup();
          }}
        >
          <i className="fas fa-calculator"></i>
          <span>
            {"Zakat"}
          </span>
        </a>
      </div>
      <RahmaUnifiedChat onToggle={onToggleRahmaChat} />
    </>
  );
}
